//On met ici les informations pour faire du RAG
export const localRAGinformations = `

`;
